import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/from';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/zipAll';

@Injectable()
export class SurveyFormService {
    private static instance: SurveyFormService = null;


    public static getInstance(http: HttpClient): SurveyFormService {
        if (SurveyFormService.instance === null) {
            SurveyFormService.instance = new SurveyFormService(http);
        }
        return SurveyFormService.instance;
    }
    constructor(private http: HttpClient) { }

    GetFormQuestions(): Observable<any[]> {
        var headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        var content = {};
        return this.http.post(location.protocol + "//" + window.location.host + "/" + window.location.pathname.split('/')[1] + "/Test/PlayTest.aspx/GetJSonObjects", content).map(
            (response: any) => response
        );

    }
    StoreFileData(file: any): Observable<any[]> {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        var content = { fileData: file.content, fileName: file.name };
        return this.http.post(location.protocol + "//" + window.location.host + "/" + window.location.pathname.split('/')[1] + "/Test/PlayTest.aspx/StoreFileData", content).map(
            (response: any) => response
        );

    }
    StoreFormQuestionsResponse(userResponse: any): Observable<any[]> {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        var content = { userResponseObject: userResponse };
        return this.http.post(location.protocol + "//" + window.location.host + "/" + window.location.pathname.split('/')[1] + "/Test/PlayTest.aspx/StoreTestData", content).map(
            (response: any) => response
        );

    }

}



// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/_services/surveyFormService.ts